import React from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import HomePage from '../routes/HomePage';
import CategoryPage from '../routes/CategoryPage';
import CategoryVideoPlay from '../routes/CategoryVideoPlay';
import SubscriptionPage from '../routes/SubscriptionPage';
import LoginPage from '../routes/LoginPage';
import RedirectPage from '../routes/RedirectPage';
import Auth from '../components/Auth';

const Routing = () => {
    const router = createBrowserRouter([{
        path: "/home",
        element:
            <Auth>
                <HomePage />
            </Auth>
    },
    {
        path: "/category/:category_name",
        element:
            <Auth>
                <CategoryPage />
            </Auth>
    },
    {
        path: "/category/video/play",
        element:
            <Auth>
                <CategoryVideoPlay />
            </Auth>
    },
    {
        path: "/",
        element: <SubscriptionPage />
    },
    {
        path: "/redirect",
        element: <RedirectPage />
    },
    {
        path: "/login",
        element: <LoginPage />
    },
    {
        path: "*",
        element: <Navigate to={"/"} />
    }
    ])

    return (
        <RouterProvider router={
            router
        } />
    )
}

export default Routing